export default {
  data() {
    return {
      missionPhoneId: null,
      patientId: null,
      typeOfEmergencyId: null,
      missionType: null,
      missionMainType: null,
      hasMisssionType: false,
      followUpPatientTab: null,
      patientAge: null,
      patientMonth: null,
      tab1Class: 'active-tab',
      tab2Class: 'deactive-tab',
      tab3Class: 'deactive-tab',
      tab4Class: 'deactive-tab',
      tab1Steps: [
        {
          insideText: 'اطلاعات اولیه',
          text: '1',
          state: 'active',
          borderClass: 'active-step-border',
          stepClass: 'active-step',
          insideClass: 'active-step-inside-text  mt-3 mr-3',
          textClass: 'step-text',
          showHR: true,
          hrClass: 'tab-active-divider',
          id: 1,
          isActive: true,
        },
        {
          insideText: 'ارزیابی اولیه',
          text: '2',
          state: 'deactive',
          borderClass: '',
          stepClass: 'deactive-step',
          insideClass: 'deactive-step-inside-text  mt-2 mr-3',
          textClass: 'deactive-step-text',
          showHR: true,
          hrClass: 'tab-deactive-divider',
          id: 2,
          isActive: true,
        },
        {
          insideText: 'نوع ماموریت',
          text: '3',
          state: 'deactive',
          borderClass: '',
          stepClass: 'deactive-step',
          insideClass: 'deactive-step-inside-text  mt-2 mr-3',
          textClass: 'deactive-step-text',
          showHR: false,
          hrClass: 'tab-deactive-divider',
          id: 3,
          isActive: true,
        },
      ],
      tab1step: 1,
    };
  },
  methods: {
    changeTab: function (tab) {
      if (!this.patientId) {
        if (!this.hasMisssionType) {
          this.snackText = 'لطفا ابتدا اطلاعات و ارزیابی اولیه را تکمیل نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
        return;
      }
      if (tab == 1) {
        this.followUpPatientTab = 1;
        this.tab1Class = 'active-tab';
        this.tab2Class = 'deactive-tab';
      } else if (tab == 2) {
        if (!this.hasMisssionType) {
          this.snackText = 'لطفا نوع ماموریت را انتخاب نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
        this.followUpPatientTab = 2;
        this.tab1Class = 'deactive-tab';
        this.tab2Class = 'active-tab';
      }
    },
    changeTab1Step: function (step, isActive) {
      if (!this.patientId) {
        return;
      }
      if (step == 1) {
        if (isActive == true) {
          this.tab1step = 1;
          this.tab1Steps = [
            {
              insideText: 'اطلاعات اولیه',
              text: '1',
              state: 'active',
              borderClass: 'active-step-border',
              stepClass: 'active-step',
              insideClass: 'active-step-inside-text  mt-3 mr-3',
              textClass: 'step-text',
              showHR: true,
              hrClass: 'tab-active-divider',
              id: 1,
              isActive: true,
            },
            {
              insideText: 'ارزیابی اولیه',
              text: '2',
              state: 'deactive',
              borderClass: '',
              stepClass: 'deactive-step',
              insideClass: 'deactive-step-inside-text  mt-2 mr-3',
              textClass: 'deactive-step-text',
              showHR: true,
              hrClass: 'tab-deactive-divider',
              id: 2,
              isActive: true,
            },
            {
              insideText: 'نوع ماموریت',
              text: '3',
              state: 'deactive',
              borderClass: '',
              stepClass: 'deactive-step',
              insideClass: 'deactive-step-inside-text  mt-2 mr-3',
              textClass: 'deactive-step-text',
              showHR: false,
              hrClass: 'tab-deactive-divider',
              id: 3,
              isActive: true,
            },
          ];
        }
      } else if (step == 2) {
        if (isActive == true) {
          this.tab1step = 2;
          this.tab1Steps = [
            {
              insideText: 'اطلاعات اولیه',
              text: '1',
              state: 'finish',
              borderClass: '',
              stepClass: 'finish-step',
              insideClass: 'finish-step-inside-text mt-3 mr-3',
              textClass: 'finish-step-text',
              showHR: true,
              hrClass: 'tab-finish-divider',
              id: 1,
              isActive: true,
            },
            {
              insideText: 'ارزیابی اولیه',
              text: '2',
              state: 'active',
              borderClass: 'active-step-border',
              stepClass: 'active-step',
              insideClass: 'active-step-inside-text  mt-3 mr-3',
              textClass: 'step-text',
              showHR: true,
              hrClass: 'tab-active-divider',
              id: 2,
              isActive: true,
            },
            {
              insideText: 'نوع ماموریت',
              text: '3',
              state: 'deactive',
              borderClass: '',
              stepClass: 'deactive-step',
              insideClass: 'deactive-step-inside-text  mt-2 mr-3',
              textClass: 'deactive-step-text',
              showHR: false,
              hrClass: 'tab-deactive-divider',
              id: 3,
              isActive: true,
            },
          ];
        }
      } else if (step == 3) {
        if (isActive == true) {
          this.tab1step = 3;
          this.tab1Steps = [
            {
              insideText: 'اطلاعات اولیه',
              text: '1',
              state: 'finish',
              borderClass: '',
              stepClass: 'finish-step',
              insideClass: 'finish-step-inside-text mt-3 mr-3',
              textClass: 'finish-step-text',
              showHR: true,
              hrClass: 'tab-finish-divider',
              id: 1,
              isActive: true,
            },
            {
              insideText: 'ارزیابی اولیه',
              text: '2',
              state: 'finish',
              borderClass: '',
              stepClass: 'finish-step',
              insideClass: 'finish-step-inside-text mt-3 mr-3',
              textClass: 'finish-step-text',
              showHR: true,
              hrClass: 'tab-finish-divider',
              id: 2,
              isActive: true,
            },
            {
              insideText: 'نوع ماموریت',
              text: '3',
              state: 'active',
              borderClass: 'active-step-border',
              stepClass: 'active-step',
              insideClass: 'active-step-inside-text mt-2 mr-3',
              textClass: 'step-text',
              showHR: false,
              hrClass: 'tab-active-divider',
              id: 3,
              isActive: true,
            },
          ];
        }
      } else if (step == 4) {
        if (!this.hasMisssionType) {
          this.snackText = 'لطفا نوع ماموریت را انتخاب نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
        this.changeTab(2)
      }
    },
    showAlert: function (text) {
      this.snackText = text;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
      return;
    },
  },
};
